import ExcludeFromLookup from '../../../../../enums/ExcludeFromLookup';

export default {
  name: 'defaultDeliveryAddress',
  type: 'checkbox',
  value: true,
  key: 'deliveryAddress--useAsDefault',
  id: 'use-this-address-as-delivery-default',
  label: 'checkout.delivery.address.field.use.as.default',
  excludeFromAddressLookup: ExcludeFromLookup.AFTER,
};
